angular
    .module('rating.uno.components', ['app.services'])
    .component('ratingUno', {
        templateUrl: 'ng/components/rating/rating.uno.view.html',
        controllerAs: 'RatingUnoCtrl',
        bindings: {
            //oggetto del componente che prende in ingesso la partitaIva
            partitaIva: '<'
        },
        controller: function ($scope, HttpService, $sessionStorage, $rootScope, $location, validationService, $searchUserService, $simulationService, FactoryObj, $filter, $translate, es6Factory, $monitoringService, $featureService, $financialService) {
            var self = this;



            self.partitaIva = self.partitaIva || '09435590154';
            self.$onInit = function () {

                $financialService.getRatingCGS(self.partitaIva)
                    .then(function (resp) {
                        var info = resp.dloGetRatingCGSOutput;
                        self.percentualeGaranziaRating = info.garanzia;
                        self.valoreDelRating = info.rating;

                        console.log('resp: ', info);

                    }).catch(function (data) {
                        $rootScope.$broadcast("addAlert", {
                            text: 'ERROR_NEXT'
                        });
                    });
            };

        }
    });